"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _isClient = _interopRequireDefault(require("../utils/isClient"));

var _civicLogoCInvert = _interopRequireDefault(require("../../assets/civic-logo-c-invert.svg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var styles = {
  height: "60px",
  width: "auto"
};

var CivicLogoCInverted = function CivicLogoCInverted(_ref) {
  var alt = _ref.alt;
  return _isClient["default"] && _react["default"].createElement("img", {
    style: styles,
    src: _civicLogoCInvert["default"],
    alt: alt
  });
};

CivicLogoCInverted.displayName = "Logo";
CivicLogoCInverted.propTypes = {
  alt: _propTypes["default"].string
};
var _default = CivicLogoCInverted;
exports["default"] = _default;